import { render, staticRenderFns } from "./AccountantView.vue?vue&type=template&id=053fdac8&"
import script from "./AccountantView.vue?vue&type=script&lang=js&"
export * from "./AccountantView.vue?vue&type=script&lang=js&"
import style0 from "./AccountantView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports